<template>
  <div class="common-bg padding-nav ">
    <exchange />
    <detailBtn
      @clickHandle="setShowDetail"
      @refresh="refresh"
      label="View my History"
      :isExpanded="showDetail"
      style="margin:0.4rem 0 1.2rem 0;"
    />
    <!-- <detail v-if="showDetail" ref="exchangeDetail" /> -->
    <record-history v-if="showDetail" ref="recordHistory" />
  </div>
</template>

<script>
import exchange from "./exchange.vue";
import detail from "./detail.vue";
import detailBtn from "@/components/DetailBtn/index.vue";
import RecordHistory from "./RecordHistory.vue";
export default {
  components: {
    exchange,
    detail,
    detailBtn,
    RecordHistory
  },
  data() {
    return {
      showDetail: false
    };
  },
  computed: {},
  methods: {
    setShowDetail() {
      this.showDetail = !this.showDetail;
      this.$nextTick(() => {
        if (this.showDetail) {
          this.refresh();
        }
      });
    },
    refresh() {
      this.$refs.recordHistory && this.$refs.recordHistory.getList();
    }
  },
  created() {},
  mounted() {}
};
</script>
<style scoped lang="scss"></style>
